module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A")])]), _vm._v("s was his custom, at least while in Thunder Canyon, Mark ended each day of interviews by downing a couple of drinks and having dinner at The Hitching Post.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He didn’t feel any better about the value of his work on this story or feel any closer to wrapping it up than he had on his first day back in town. For the most part, all he could come up with was human-interest type stuff.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Public opinion, it seemed, was split when it came to the gold rush and the influx of fortune hunters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Some townspeople had gotten so excited by the fervor, they’d locked up their homes and drained their bank accounts in order to buy prospecting gear. Others—mostly business owners—were pleased by the increase in revenue the newcomers brought to town.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But then there were the vocal locals, those who hated the publicity and the swarm of strangers who’d turned the quaint little town topsy-turvy. Juliet, with her love of history, probably fell into that group.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mark scanned the room and found her near the cash register, talking to her boss. Why didn’t Martha Tasker trade jobs and let the pregnant waitress sit on a stool while collecting payments and making change? It wouldn’t hurt the older woman to take orders and serve customers for the time being.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Juliet walked away, she massaged the small of her back with both hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Damn. It grated on Mark to see her working so hard. And hurting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But hey, he reminded himself. That really wasn’t any of his business. He ought to be relieved that she hadn’t waited on him this evening. That she hadn’t made any effort to stop by his table—in spite of the friendly conversation they’d shared last night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yet the fact that she hadn’t come by bothered him, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He missed her smile, her wit. Her company.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But then why wouldn’t he? Juliet was about the only person, place or thing in this town he found interesting or appealing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And she hadn’t looked his way this evening.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Was she avoiding him? Had he been too intrusive last night? Offering his opinion and advice without being asked?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe so, but that was just as well.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("Last night, following their chat, he’d gone back to ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("the Wander-On Inn and, when he’d finally dozed off, he’d slept like hell, tossing and turning all night long like a trout trapped in shallow water.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced up from the trace of meat loaf and mashed potatoes on his plate and saw her coming his way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Well, what do you know? Speak of the pretty devil who’d triggered his insomnia.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she reached his table, she smiled. “Mary Sue had to go home because of a family emergency. So I’m going to be taking care of you from here on out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re the one who should be cutting out early. And someone ought to be taking care of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She arched, grimaced, then rubbed her lower back. “We’ve already talked about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They had. And he hadn’t meant to get her all riled up. After all, it wasn’t his place to harp on her. And even if she appreciated his concern, he wouldn’t be around long enough to nurture a friendship. Besides, he damn sure didn’t need to get involved with a single mother and her child, especially when they lived in a town he’d been avoiding for twenty years.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry, Juliet. I’ll let it go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks.” She offered him an olive-branch smile. “I’m trying to take it easy, Mark. But I’ve got to keep working a little while longer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He nodded. She was concerned about finances, which was understandable. Once she gave birth and went back to work, the cost of a babysitter would probably put a crunch on her paycheck.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe he ought to give her some money. Five hundred dollars might make life a bit easier for her. And then he could let it go. Ease off. Let her be.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can I get you some dessert?” she asked. “Buck made his blue-ribbon peach cobbler today. And everyone’s been raving about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure. I’ll take some.” Mark placed his napkin on the table and pushed aside his dinner plate. “Will you join me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe for a minute.” She glanced over her shoulder at Martha, who appeared preoccupied with sorting bills in the cash drawer. “I’ve had a nagging backache all afternoon.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mark couldn’t hold back a grumble. If he were a violent man, he’d slam a fist on the table in frustration. Was a backache normal for a woman in her condition? Or was it an indication that something was wrong? Something terribly wrong? Something that put her life and that of her baby at risk?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Like Kelly.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Damn the memory that wouldn’t let him alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No matter what he’d told himself, no matter what kind of truce he and the waitress had drawn, Mark couldn’t shake his concern. “I’m glad you’re going to take a break, but come on, Juliet. You really need to go home and put your feet up. Think about the baby.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("“I am.” Her eyes locked on his in rebuttal, although they appeared a bit glassy, like they were swimming in emotion and barely staying afloat. “I don’t have a family to fall back on. It’s just the baby and me. And I can’t help worrying about making ends meet, about ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("keeping a roof over our heads once he or she gets here.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, well unless you want that baby to get here too soon, you’d better heed the doctor’s advice and quit work.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tonight, when I clock out, I’ll ask for a couple of days off. Okay?” She lifted a delicate brow, as though cueing him to agree.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He merely blew out a sigh, giving in—so it appeared. He didn’t usually offer unsolicited advice. It wasn’t normally his style. But then again, he wasn’t reminded of Kelly that often. Of her unnecessary death.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Juliet seemed to accept his silence as acquiescence, which it was. But her weary smile didn’t take the edge off the exhaustion in her expression. Nor did it erase the dark circles he hadn’t noticed under her eyes last night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll have two peach cobblers,” he said. “And a glass of milk.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d think the milk might curdle in your stomach with the bourbon you drank earlier.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The milk is for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded, then went after the dessert. When she returned, she took a seat. “How’s your story coming along?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What story? This assignment is a joke.” And it was, compared to the bigger stories he’d covered in the past. Important events that made him feel as though he’d reached the professional level he’d strived for, that level where one man—a reporter—could make a difference in people’s lives.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You think the gold rush is a joke?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Writing a story about a bunch of loony-tune prospectors who’ve flocked to a possible gold rush in Thunder Canyon can’t even come close to a story about a major flood or fire.” He dug into the cobbler and scooped out a gooey bite. Hmmm. Not bad.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he glanced up, he caught Juliet’s eye, her rapt attention.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’d rather write about disasters?” she asked. “Why such depressing news?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It touches hearts, confronts our deepest fears. Stirs up emotion.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We had a fight in here last Saturday night. There was plenty of emotion stirring then.” Her lips quirked into a grin, and he realized she was teasing him, trying to chip away at the cynical armor it had taken him years to build.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A fight, huh? I’m sorry I missed the entertainment. But not to worry. I can go down to the E.R. at Thunder Canyon General and watch them stitch up the scalp of some idiot who tripped over a pickax and split his head open.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So this is small tomatoes for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Small potatoes,” he corrected, unwilling to reveal his disappointment, his frustration. His desire to make a difference, to help people—victims of disasters. And to better prepare people who hadn’t been stricken by major calamities yet. He shrugged. “I’ll get the job done.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("“You know,” she said, licking a dollop of peach cobbler from her fork. “There have been some gold ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("nuggets found. So one of the prospectors "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("could")]), _vm._v(" strike it rich.”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe. But I think the biggest story I’ve got is the hullabaloo about the ownership of the old mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I thought Caleb Douglas owned it. That his great-grandfather won it in a poker game with the Shady Lady.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s the legend that’s been circulating for years. People have just assumed that Caleb was the owner. But he hasn’t produced the deed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She furrowed her brow. “What about the county records?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They’re not available right now. Harvey Watson, the clerk who’s been transcribing all the old records into the new computer system, is on vacation.” Mark slowly shook his head. “Can you believe, in this day and age, that Thunder Canyon would be so far behind the times?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Like I told you before, I think this historical old town is quaint.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He leaned back in his chair, watched the innocence dance in her eyes and smiled. “You must have some Amish in your genes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry, no Amish. Just a little Basque, a drop or two of French. But mostly, a healthy blend of proud Mexican and Old World Spanish.” She smiled and gave a little wink. “Maybe I was born in the wrong century.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was definitely unique. A novelty. And as far as he was concerned, her bloodlines were damn near perfect.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("“So, who do you think owns the Queen of Hearts ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("mine?” she asked. “You ought to have an idea. After all, you’re a local boy.”")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" local. Mark hadn’t moved to Thunder Canyon until he was thirteen. And he was long gone five years later. “I think Caleb Douglas owns the property, and it’s just a matter of a misplaced deed and some backward record keeping in a land office. Anyway, that’s my guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She took a sip of milk, and he watched the path of her swallow. She had a pretty neck. Regal and aristocratic. The kind of throat and neck a man liked to nuzzle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she lowered the glass, she wore a spot of white at the edge of her mouth. Unable to help himself, he reached out and snagged it with his thumb.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her lips parted, and something—he sure as hell didn’t know what—passed between them. An awareness. An intimacy. Something he hadn’t bargained for.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I…umm…I’m sorry. You had a little milk…” He pointed to her cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Juliet swiped her fingers across her mouth, trying to remove any trace of milk that still lingered. Or maybe she was trying to prolong the stimulating warmth of Mark’s touch. The flutter of heat his thumb had provoked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For goodness’ sake. She was acting like a school-girl with a crush on the substitute teacher, a handsome young man fresh out of college and thrown into a classroom of adolescents. Or on a guy who was way out of her league. And that was crazy.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With the healthy sense of pride Papa and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abuelita")]), _vm._v(" had instilled in her, there weren’t too many people—or men—Juliet would consider above her reach.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, being nearly eight months pregnant certainly left her out of the running when it came to romance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She glanced across the room, eager to break eye contact, or whatever was buzzing between her and Mark, and spotted Mrs. Tasker sitting in the swivel seat at the register. The older woman wore a frown that made the wrinkles around her eyes more pronounced.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Were her ingrown nails giving her trouble again tonight? Or did she think Juliet had a crush on the handsome older man, that she was trying to strike up a relationship with a customer?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe she was thinking Juliet ought to get back to work.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, for Pete’s sake,” Mark said. “Tell Attila the Hun to back off and let you have a decent break.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was right—not about Mrs. Tasker being a barbarian, but about Juliet needing to quit for today. This darn backache was getting to her. “I’ll take the rest of the night off, all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s better yet.” He caught her fingers in a gentle squeeze before releasing them. But the brief connection remained, humming between them as though he hadn’t let go.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shook it off, blaming her hormones and the loneliness that seemed to haunt her at times, ever since her brother’s accident.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("It had been two years, although time had eased the ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("pain and dulled the shock, as Father Tomas had told her it would. But time hadn’t done a darn thing to ease the loneliness or to change the fact she didn’t have a family anymore.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She brushed a hand along the contour of her tummy, caressed the knot that sprung up on the left side. A little foot? A knee? A fist?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she stood, the muscles of her back gripped hard, causing her to bend and grab the table for support.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s the matter?” Mark jumped to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a woman with bad feet, Mrs. Tasker was by her side in an instant. “Are you in labor?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Juliet froze as the possibility momentarily hovered over her like the calm before the storm. “No, I don’t think so.” At least, she hoped not. It was still too early.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As the ache in her back continued, she closed her eyes. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dios, por favor.")]), _vm._v(" Don’t let it happen now. It’s too soon.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you having a contraction?” Mrs. Tasker asked, glancing at her wristwatch, as though she meant to start timing the pains.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s just a backache,” Juliet said, willing it to be true.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The older woman crossed her arms in an all-knowing fashion. “That’s how my labor started with Jimmy. All in my back.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Juliet lifted her gaze, looked at Mark, expecting him to blurt out a gripe, a complaint, an I-told-you-so. But the only sign of his response was a tense jaw, a pale face.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No need for us to take any chances,” Mrs. Tasker said. “I’ll call an ambulance.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t bother.” Mark reached into his back pocket, took out his wallet, withdrew a twenty-dollar bill and dropped it on the table. “I’ll take her to the hospital.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Juliet began to object, to tell him to finish his dessert. But he slipped an arm around her and led her to the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mark followed White Water Drive to Thunder Canyon General, then veered toward the separate emergency entrance. He stopped under the covered portico, close to the automatic glass doors, and threw the car into park. “Wait here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leaving Juliet in the idling car, he dashed inside past a security guard, his heart pounding as though he had a personal stake in this—and he sure as hell didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Mark knew firsthand how things could go wrong during labor. And he wasn’t going to leave Juliet, who didn’t have anyone to depend on, to fend for herself. Neither was he going to let her ignore any symptoms that might be serious.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He spotted a nurse behind the reception desk. “I need help. Now. I’ve got a woman in my car who may be in premature labor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The nurse grabbed a wheelchair and followed him outside. But rather than take Juliet right to a room, she stopped at the reception desk.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can’t this wait?” Mark asked, growing more agitated by the second. He wanted to hand over Juliet to a qualified professional, then get the heck out of here.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry,” the nurse responded. “This will only take a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was wrong. But while the customary paperwork was filled out, Mark managed to not pitch a fit about the amount of time it took.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally, Juliet was given a temporary bed in the E.R. Her only privacy was a blue-and-white striped curtain that didn’t reach the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before long, she’d had her temperature and blood pressure taken—all within normal range.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mark really ought to loosen up. Normal was a good thing, right?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you notify your physician that you were coming in?” the nurse asked Juliet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t have time to think about it.” Juliet glanced at Mark and blew out a sigh. “Can you tell Dr. Emerson that I’m here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The nurse, a matronly blonde, placed a hand on Juliet’s shoulder. “Dr. Emerson had a heart attack last night and is in ICU.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Juliet gasped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But don’t you worry,” the nurse said. “We have a top-notch resident obstetrician who will take good care of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dr. Hart?” Juliet asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The nurse smiled. “That’s right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I saw her on Sunday afternoon. I’d had a fainting spell. And you’re right. I felt very comfortable with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good,” the nurse said. “I’ll give Dr. Hart a call and see whether she’d like us to examine you down here or send you to maternity on the second floor.”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Juliet uttered an okay. She might be comfortable with the resident obstetrician, but Mark could see the worry in her eyes. The anxiety in her face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In the meantime,” the nurse said, pointing to a chair beside the bed. “Why don’t you have a seat, Dad?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dad? She had that all wrong. But before Mark could explain, Juliet did it for him. “This is my friend, Mark Anderson. He’s not the baby’s father.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The nurse smiled. “It’s nice for a woman to have someone she trusts be her birth coach.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Birth coach? Whoa. Not Mark. He’d just brought Juliet here to make sure she saw a doctor, that she was someplace safe. Maybe he could stick around and hold her hand for a while. But if things got hairy, if she was really in labor, he’d wait in the cafeteria until she gave birth. Heck, he might even hang around long enough to look at the baby behind a glass window and tell her the kid was cute—even though he’d seen a couple of newborns and thought they looked more like aliens than humans.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then, after that, he’d be on his way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When the nurse stepped out, Mark took a seat, but he couldn’t seem to relax. What was taking so long? He glanced at his watch. The minute hands seemed to be moving slower than usual.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A while later—he didn’t know how long—another nurse arrived. A friendly, thirty-something woman with short, dark-hair and wearing a pink smock dotted with teddy bears. “Ms. Rivera? I’m Beth Ann. Dr. Hart has asked me to take you to maternity.”")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The nurse fiddled with the bed, making it mobile, then began to push Juliet out of the E.R. and into the hall. She slowed her steps just long enough to glance at Mark. “You can follow us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He opened his mouth to object, to say he’d be having coffee in the cafeteria, but for some reason, he fell into step behind the rolling bed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They took an elevator to the second floor, then the nurse wheeled Juliet toward the maternity ward, where she paused before the ominous double doors.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mark’s steps slowed, too. But not because he was tagging along behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What the hell was he doing? Juliet was in good hands. Competent hands. He didn’t need to go in there. They didn’t need "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v(". Besides, he’d done his duty. His good deed for the day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But when Juliet turned her head and looked at him, those misty, mahogany eyes locking on his, he saw the fear, the nervousness. The need.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He offered her a wimpy smile, and when she turned her head away, he ran a hand through his hair. He didn’t have any business going in there with her. He wasn’t the baby’s father. Or her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Juliet didn’t have a mother or a sister. She was new in town. And he doubted she’d made any friends, not with her schedule. Hell, none of her co-workers had jumped in to help.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Right now, she only had him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The nurse pressed at the button that automatically swung open the doors, then pushed Juliet through.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mark followed behind, like a clueless steer on its way to a slaughterhouse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They plodded along the hall, his Italian loafers clicking on the spanking clean floor, the nurse’s rubber soles making a dull squeak with each step. They passed several open doorways Mark was afraid to peek into and continued along a glass-enclosed room that held incubators for the tiniest and sickest of patients. All of the little beds were empty, thank God.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Would Juliet’s baby be placed in one of them?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The possibility jolted his heart, jump-starting his pulse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh, for cripes sake. Mark wasn’t a worrier. Not by nature. It was just the pregnancy, the vulnerability of both woman and child.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And his own fears brought back to life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He swore under his breath. Juliet was just having a backache, right? From working too hard and carrying the extra weight of a baby. She hadn’t been especially worried until Martha Tasker popped up like a jack-in-the-box, with the tale of her own labor, stirring things up. Making something out of nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mark followed the bed into a room that looked more like a bedroom than a private hospital room. Pale green curtains graced the window that looked out into a frozen courtyard that was probably colorful and vibrant during the summer.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("Decorated in pink, green and a touch of lavender, the color scheme and homey touch of the room probably helped ease the nerves of laboring expectant mothers. But it didn’t do a damn thing to ease Mark’s ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("anxiety, not when he spotted medical gaskets and gizmos that reminded him of where they were, what they faced.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here’s a gown,” Beth Ann said. “As soon as you slip it on, I’ll examine you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An examination? Oh, cripes. Not an internal exam.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The nurse asked Juliet, “Would you like him to stay in here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh, hell no. Not on a bet. Mark cleared his throat, then started backing toward the door. “Why don’t I step out of the room for a little while. You can come and get me when it’s all over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When it was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("all")]), _vm._v(" over. Not just the exam.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The nurse nodded as she reached for a box of rubber gloves.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mark couldn’t get out of the birthing room fast enough. If he ever had a kid of his own, he wouldn’t be hanging around and watching that kind of a procedure. No way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He ran a finger under the collar of his shirt, then scanned the hospital corridor, where a floral wallpaper border softened the sterile white walls.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If there’d been anyone else who could be here for Juliet, he’d be out of here faster than a sopping-wet dog could shake its fur.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she didn’t have anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And that’s why he stayed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Moments later, the nurse poked her head out the door. “You can come in now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He nodded, then stepped inside. But before he reached Juliet’s bed, an attractive woman dressed in medical garb approached and introduced herself as Dr. Hart.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think she’s in the early stages of labor,” the nurse told the obstetrician. “And she’s about two centimeters dilated.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. Hart nodded, then approached Juliet. “I’d feel better about delivering your baby a couple weeks from now. So I’d like to give you something to stop labor and another medication that will help the baby’s lungs develop quicker, in case your labor doesn’t respond to treatment.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When the doctor and nurse left them alone, Juliet shot Mark a wobbly grin. “You don’t have to stick around. I’ll be okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hey, there was his out. His excuse to leave. But he couldn’t take it, couldn’t walk away knowing she was all alone. “What if you need a ride home?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can take a cab.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t be ridiculous.” Then he sat back in his chair, unsure of what the night would bring.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And hoping to hell he could step up to the plate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This time.")])])])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page37"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e9a7a60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426887581_ch02.vue
// module id = 84
// module chunks = 0